import React from 'react';

import Button from '../../components/buttons/Button';
import Btvoltar from '../../components/buttons/Btvoltar';
import STRINGS from './../../data/language/language';
import PagamentoCartao from './PagamentoCartao';
import PagamentoBoleto from './PagamentoBoleto';
import Dialog from '../../components/alert/Dialog';

import { WS_PAGAMENTO } from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import SHIELD from '../../img/shield.svg';
import { PLANOS_BOX } from '../../config/Config';

import FbPixel from '../fbPixel/FbPixel';

import Recaptcha from 'react-recaptcha';
import { GOOGLE_RECAPTCHA_V2 } from '../../config/Config';

const URL_CADASTRAR_CARD = WS_PAGAMENTO.adesaoByCard;
const URL_CADASTRAR_BOLETO = WS_PAGAMENTO.adesaoByBoleto;
const MENSAL = 'M';

export default class Efetuarpagamento extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      dono_dt_nasc: '',
      dono_cpf: '',
      nome_cartao: '',
      cpf_cnpj: '',
      cartao: '',
      data_expiracao: '',
      cvc: '',
      li_concordo: '',
      tipo_pagamento: 'cartao',
      strings:STRINGS[window.LANGUAGE],
      brands: [],
      gCaptcha: null
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  componentDidMount(){
    const data = {};
    FbPixel.addTrack({event:'AddPaymentInfo', data:{}});

    if (this.captchaDemo) {
      this.captchaDemo.reset();
    }
  }

  onLoadRecaptcha() {
    if (this.captchaDemo) {
        this.captchaDemo.reset();
    }
  }

  verifyCallback(recaptchaToken) {
    this.setState({
      gCaptcha: recaptchaToken
    });
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {

    if(this.state.tipo_pagamento === 'cartao'){
      this.payWithCard(event);
    }else{
      this.payWithBoleto(event);
    }

    event.preventDefault();
  }

  changeStep(e){
    e.preventDefault();
    this.props.changeBox();
  }

  //-----------------------------
  payWithCard(event) {
      const form = document.getElementById('form-pagamento');
      const self = this;
      const nomeCartao = form.querySelectorAll("[name='nome_cartao']")[0].value;
      const cartao = form.querySelectorAll("[name='cartao']")[0].value;
      const dataExpiracao = form.querySelectorAll("[name='data_expiracao']")[0].value;
      const cvc = form.querySelectorAll("[name='cvc']")[0].value;
      const brand = document.getElementById('input-brand').value;

      //self.succesBuyingCard();
      //return false;

      const {
        atencao,
        preenchaBandeira,
        todoscamposObrigatorios,
        preenchaParcelas,
        li_concordo
      }
      = this.state.strings;

      if(!brand){
        const msg = {
          title: atencao,
          text: preenchaBandeira
        };
        Dialog.create(msg);
        return false;
      }

      if(!nomeCartao || !cartao || !dataExpiracao || !cvc){
        const {
          atencao,
          todoscamposObrigatorios
        }
        = this.state.strings;
        const msg = {
          title: atencao,
          text: todoscamposObrigatorios
        };
        Dialog.create(msg);
        return false;
      }

      //se o pagamento for mensal não temos parcelamento
      if(this.props.dados.periodicidade !== MENSAL){
        const parcelas = form.querySelectorAll("[name='parcelas']")[0].value;
        if(!parcelas){
          const {
            atencao,
            preenchaParcelas
          }
          = this.state.strings;
          const msg = {
            title: atencao,
            text: preenchaParcelas
          };
          Dialog.create(msg);
          return false;
        }
      }

      //Li e concordo
      /*if(!this.state.li_concordo){
        const msg = {
          title: atencao,
          text: li_concordo
        };
        Dialog.create(msg);
        return false;
      }*/

      self.makePaymentByCard();
    }

    makePaymentByCard() {
      const form = document.getElementById('form-pagamento');
      const self = this;
      const nomeCartao = form.querySelectorAll("[name='nome_cartao']")[0].value;
      const cartao = form.querySelectorAll("[name='cartao']")[0].value;
      const dataExpiracao = form.querySelectorAll("[name='data_expiracao']")[0].value;
      const cvc = form.querySelectorAll("[name='cvc']")[0].value;
      const monthData = dataExpiracao.split('/')[0];
      const yearData = dataExpiracao.split('/')[1];
      const senderHash = this.props.senderHash;
      const plano = this.state.plano;
      const planoId = this.props.dados.id;
      const email = this.props.email;

      const brand = document.getElementById('input-brand').value;

      const {
        atencao,
        salvoSucesso,
        preenchaCamposAsterisco,
        erroSalvar,
        usuarioSenha,
        erroLogar,
        preenchaGoogleCaptcha
      }
      = self.state.strings;

      const dadosSend = {
        card_number: cartao,
        holder: nomeCartao,
        expiration_date: dataExpiracao,
        security_code: cvc,
        brand,
        id_plano: planoId
      };

      if(this.props.dados.periodicidade !== MENSAL){
        const parcelas = form.querySelectorAll("[name='parcelas']")[0].value;
        dadosSend.installments = parcelas;
      }

      const gCaptcha = this.state.gCaptcha;

      if(!gCaptcha){
        const msg = {
          title: atencao,
          text: preenchaGoogleCaptcha
        };
        Dialog.create(msg);
        return;
      }

      dadosSend.gCaptcha = gCaptcha;
      dadosSend.typePagamentoWeb = true;

      Requisitions({
        url: URL_CADASTRAR_CARD,
        data: dadosSend,
        sucess:function(data){
          if(data.status){
            self.succesBuyingCard();
          }else{
            var msg = {
              title: atencao,
              text: data.msg
            };
            Dialog.create(msg);
          }
          self.onLoadRecaptcha();
          self.setState({gCaptcha:null});
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroLogar
          });
        }
      });
    }

    succesBuyingCard() {
      this.props.successBuying({ type: PLANOS_BOX.pagamentoCardSuccess });
    }

    payWithBoleto() {
      const self = this;
      const senderHash = this.props.senderHash;
      const planoId = this.props.dados.id;

      const {
        atencao,
        salvoSucesso,
        preenchaCamposAsterisco,
        erroSalvar,
        usuarioSenha,
        erroLogar,
        li_concordo
      }
      = self.state.strings;

      const form = document.getElementById('form-pagamento');
      const cpf_cnpj = form.querySelectorAll("[name='cpf_cnpj']")[0].value;
      const telefone = form.querySelectorAll("[name='telefone']")[0].value;

      //Li e concordo
      /*if(!this.state.li_concordo){
        const msg = {
          title: atencao,
          text: li_concordo
        };
        Dialog.create(msg);
        return false;
      }*/

      //---------------
      //passa direto para a tela de confirmação
      //this.succesBuyingByBoleto({link:'https://google.com'});
      //return false;
      //---------------
      if(telefone && cpf_cnpj){
        Requisitions({
          url: URL_CADASTRAR_BOLETO,
          data: {
              id_plano: planoId,
              ps_hash: senderHash,
              cpf_cnpj,
              telefone
          },
          sucess:function(data){
            if(data.status){
              self.succesBuyingByBoleto(data);
            }else{
              var msg = {
                title: atencao,
                text: data.msg
              };
              Dialog.create(msg);
            }
          },
          error:function(data){
            Dialog.create({
              title: atencao,
              text: 'Ocorreu um erro ao gerar o boleto'
            });
          }
        });
      } else {
        Dialog.create({
          title: atencao,
          text: 'Preencha seu telefone e cpf'
        });
      }

    }

    succesBuyingByBoleto(data){
      this.props.successBuying({ type: PLANOS_BOX.pagamentoBoletoSuccess, link: data.link });
    }

  //-----------------------------

  render(){
    const strings = this.state.strings;
      const pagamentoBox = this.state.tipo_pagamento === 'cartao' ?
        <PagamentoCartao handleInputChange={this.handleInputChange} dados={this.props.dados} />:
        <PagamentoBoleto handleInputChange={this.handleInputChange} />;

        let brands = this.state.brands.map((value, i) =>{
          return <span key={i} className='brand-payment'><img src={value} /></span>;
        });

      const captcha = this.state.tipo_pagamento === 'cartao' ? (
        <div>
            <Recaptcha
              ref={e => this.captchaDemo = e}
              sitekey={GOOGLE_RECAPTCHA_V2}
              size="normal"
              hl="pt-BR"
              verifyCallback={this.verifyCallback}
            />
            <br />
          </div>) : null;

      return(
        <div className='box-formulario' id='form-pagamento'>
          <div className='box-title'>
            {/*<span className='cadastro-title'><strong>Cadastro - </strong>3 de 3</span>*/}
            <span className='title-box-title'>Pagamento</span>
          </div>
          <div>
            <p>Parabéns, você está a um passo de fazer parte do FOCO90</p>
            <div className='box-compra-segura'>
              <div className='box-compra-segura__inner'>
                <span className='push-left'><img src={SHIELD} width='40' /></span>
                <span className='push-left txt-compra-segura'>Compra 100% segura</span>
                <div className='clear'></div>
              </div>
            </div>
            <div className='form-pagamento'>
              <div  className='box-type-pay'>
              <div className="box-input--title">Escolha a forma de pagamento</div>
              <div className="pure-g">
                  <div className="pure-u-1-2">
                    <label htmlFor="option-two" className="pure-radio">
                        <input
                          name="tipo_pagamento"
                          id="option-two"
                          type="radio"
                          value="cartao"
                          checked={this.state.tipo_pagamento==='cartao'}
                          onChange={this.handleInputChange}
                        />
                        <span className='type-pay-txt'>Cartão de crédito</span>
                    </label>
                  </div>
                  <div className="pure-u-1-2">
                    <label htmlFor="option-two" className="pure-radio">
                        <input
                          name="tipo_pagamento"
                          id="option-two"
                          type="radio"
                          value="boleto"
                          checked={this.state.tipo_pagamento==='boleto'}
                           onChange={this.handleInputChange}
                        />
                        <span className='type-pay-txt'>Boleto</span>
                    </label>
                  </div>
              </div>
              </div>
              {pagamentoBox}
              {captcha}
            </div>
            <div>
              <div className='li_concordo'>
                  {/*<input
                    name="li_concordo"
                    type="checkbox"
                    value=""
                    checked={this.state.li_concordo}
                    onChange={this.handleInputChange}
                  />*/}
                <span className='type-pay-txt'>Ao prosseguir, você concorda com nossos <a target="_blank" href="https://foco90.com.br/termos/">termos de uso e faturamento</a> e <a target="_blank" href="https://foco90.com.br/politica-privacidade/">políticas de privacidade</a></span>
              </div>
            </div><br /><br />
            <div className="box-center-button">
              <Button
                text="Confirmar pagamento"
                type='button'
                classes="button-login simple-button"
                onClick={this.handleSubmit}
              />
            <Btvoltar text='Mudar plano' onClick={this.changeStep} />
            </div>
          </div>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/EfetuarPagamento.js